import { Stack } from "@mui/material";
import { type FC, useMemo } from "react";
import { useBrandTones } from "../../brand-kit/hooks/use-brand-tones";
import type { BrandInfoSelected } from "../../brand-kit/types";
import { useFixedProgramCarousels } from "../hooks/use-fixed-program-carousels";
import { topTenTemplatesAtom, trendingTemplatesAtom, upcomingTemplatesAtom } from "../store";
import type { DiscoverTemplate } from "../types";
import { DiscoverCardBadge } from "./discover-card-badge";
import { DiscoverCarousel } from "./discover-carousel";

export const programNameGetter = (t: DiscoverTemplate): string | null => {
  if ("program" in t) return t.program?.name;
  else return null;
};

export const DiscoverCarousels: FC<{
  brandKitSelections?: BrandInfoSelected;
}> = ({ brandKitSelections }) => {
  const { data: brandTones, loading } = useBrandTones();
  const brandTone = useMemo(() => brandTones?.find((b) => b.is_default), [brandTones]);

  const fixedProgramCarousels = useFixedProgramCarousels({
    brandKitSelections,
    brandTone,
    loading,
  });

  return (
    <Stack gap={4} pt={4}>
      <DiscoverCarousel
        title="Popular Communications"
        loading={loading}
        templatesAtom={trendingTemplatesAtom}
        brandTone={brandTone}
        brandKitSelections={brandKitSelections}
        Badge={DiscoverCardBadge}
        subheadingGetter={programNameGetter}
      />
      <DiscoverCarousel
        title="Upcoming Communications"
        loading={loading}
        templatesAtom={upcomingTemplatesAtom}
        brandTone={brandTone}
        brandKitSelections={brandKitSelections}
        subheadingGetter={programNameGetter}
      />
      <DiscoverCarousel
        title="Top 10 Communications"
        loading={loading}
        templatesAtom={topTenTemplatesAtom}
        brandTone={brandTone}
        brandKitSelections={brandKitSelections}
        Badge={DiscoverCardBadge}
        subheadingGetter={programNameGetter}
      />
      {fixedProgramCarousels}
    </Stack>
  );
};

export const programSubheadingOverrides: {
  [key: string]: (t: DiscoverTemplate) => string | null;
} = {
  holidays: (t) => (t.type === "moment" ? t.geo : null),
};
